import React, { useEffect } from 'react';
import { ThemeProvider } from '@mui/material';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';
import configureI18n from './i18n';
import { theme } from './theme';
import ErrorPage from './pages/ErrorPage';
import Routing from './routing/Routing';

configureI18n();

/**
 * Component for mounting the PS Viewer application.
 * @returns {import('react').FunctionComponent} React element that contains the application.
 */
function App() {
  const { i18n } = useTranslation();
  useEffect(() => {
    moment.locale(i18n.language);
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <ThemeProvider theme={theme}>
      <ErrorBoundary FallbackComponent={ErrorPage}>
        <Routing />
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
